(() => {
  const selector = '[id$="__pap04_reels"]';
  const init = () => {
    const root = document.querySelector(selector);
    if (!root || root.dataset.pap04SoundReady) return;
    root.dataset.pap04SoundReady = 'true';
    let current = null;
    let userMuted = false;
    let waitingForGesture = false;
    const sound = (video, muted) => {
      video.muted = muted;
      const player = video.closest('internal-video');
      if (player) player.classList.toggle('internal-video--muted', muted);
      const button = player && player.querySelector('.internal-video__sound-btn');
      if (button) button.setAttribute('aria-label', muted ? 'Activar sonido' : 'Silenciar video');
    };
    const visible = video => {
      const box = video.getBoundingClientRect();
      const area = Math.max(0, Math.min(box.bottom, innerHeight) - Math.max(box.top, 0)) *
        Math.max(0, Math.min(box.right, innerWidth) - Math.max(box.left, 0));
      return box.width && box.height ? area / (box.width * box.height) : 0;
    };
    const sync = (force = false) => {
      const videos = Array.from(root.querySelectorAll('video'));
      const candidates = videos.filter(video => visible(video) > 0.25);
      const active = candidates.filter(video => video.closest('.splide__slide.is-active'));
      const target = (active.length ? active : candidates).sort((a,b) => visible(b) - visible(a))[0];
      if (document.hidden || !target) {
        videos.forEach(video => sound(video, true));
        current = null;
        return;
      }
      if (target === current && !force) return;
      current = target;
      videos.forEach(video => { if (video !== target) sound(video, true); });
      sound(target, userMuted);
      const result = target.play();
      if (result && result.catch) result.catch(() => {
        if (current !== target || !root.isConnected) return;
        waitingForGesture = !userMuted;
        sound(target, true);
        const fallback = target.play();
        if (fallback && fallback.catch) fallback.catch(() => {});
      });
    };
    const observer = new IntersectionObserver(() => sync(), {threshold:[0,0.25,0.5,0.75,1]});
    root.querySelectorAll('video').forEach(video => {
      observer.observe(video);
      video.addEventListener('loadeddata', () => { if (current === video) sync(true); });
    });
    const changes = new MutationObserver(() => sync());
    root.querySelectorAll('.splide__slide').forEach(slide => changes.observe(slide, {attributes:true,attributeFilter:['class']}));
    root.addEventListener('click', event => {
      const button = event.target.closest('.internal-video__sound-btn');
      if (!button) return;
      const video = button.closest('internal-video').querySelector('video');
      setTimeout(() => {
        userMuted = video.muted;
        waitingForGesture = false;
        current = video;
        root.querySelectorAll('video').forEach(other => { if (other !== video) sound(other, true); });
        sound(video, userMuted);
      }, 0);
    });
    const gesture = event => {
      if (!root.isConnected) {
        observer.disconnect();
        changes.disconnect();
        document.removeEventListener('click', gesture);
        document.removeEventListener('keydown', gesture);
        return;
      }
      if (waitingForGesture && !event.target.closest('.internal-video__sound-btn')) {
        waitingForGesture = false;
        sync(true);
      }
    };
    document.addEventListener('click', gesture);
    document.addEventListener('keydown', gesture);
    document.addEventListener('visibilitychange', () => sync());
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();